import {
  assoc,
  curry,
  defaultTo,
  keys,
  pipe,
  reduce,
  toPairs,
  map,
} from "ramda";

export function getDefaultObjectFromObjectAttributes(attributes) {
  let data = {};
  attributes.map((item) => {
    data = assoc(item.name, item.defaultValue)(data);
  });
  return data;
}

export const renameKeys = curry((keysMap, obj) =>
  reduce((acc, key) => assoc(keysMap[key] || key, obj[key], acc), {}, keys(obj))
);

export const roundUpCoordinate = (coordinate) => {
  return Math.round(coordinate * 100) / 100;
};

export const convertMacrosObjectToArray = (data) => {
  return pipe(
    defaultTo({}),
    toPairs,
    map(([k, v]) => ({
      label: k,
      value: v,
    }))
  )(data);
};

export const transformValueForZapierAndMake = (data) => {
  const regex = /{{(.*?)}}/g;
  const changedRegex = /\[\[(.*?)\]\]/;
  const result = data.replace(regex, "[[$1]]");
  if (changedRegex.test(result)) {
    return result.concat("##replaceSquareBracketsToCurlyBrackets##");
  }
  return result;
};
